import { render, staticRenderFns } from "./shopMonitor.vue?vue&type=template&id=5c0f4c5d&scoped=true&"
import script from "./shopMonitor.vue?vue&type=script&lang=js&"
export * from "./shopMonitor.vue?vue&type=script&lang=js&"
import style0 from "./shopMonitor.vue?vue&type=style&index=0&id=5c0f4c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f4c5d",
  null
  
)

export default component.exports